export interface ClientData {
  contactInfo: {
    primaryEmailAddress: string;
    preferredName?: string;
  };
  birthDate: string;
  citizenship: string;
  firstName: string;
  middleName: string;
  lastName: string;
  tin_private: string;
  phoneNumber: string;
  isMobile: boolean;
  incapacitated: boolean;
  gender: string;
}

export interface ClientSegment {
  segmentTypeCode: string;
  digitalAdviseService: boolean;
  savings529Account?: boolean; //pre graphql
  smallMarket401kAccount?: boolean; //pre graphql
  savings529BeneficiaryOnly?: boolean; //post graphql
  smallMarket401kAccountOnly?: boolean; //post graphql
}
